import styled, { css } from 'styled-components'

import { color, spacing, typography } from '../../themes'

export type Size = 'default' | 'sm' | 'lg'
export type Gap = 'default' | 'lg' | 'auto'

export const Info = styled.span`
  ${typography('body1')};
  display: flex;
  align-items: center;
  color: ${color('gray.02')};
  margin-left: ${spacing(2)};

  & > span {
    margin-left: ${spacing(0.5)};
  }
`

interface ContainerProps {
  size?: Size
  gap?: Gap
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;

  ${({ gap }) =>
    gap === 'auto' &&
    css`
      justify-content: space-between;
    `}

  & > *:not(:first-child):not(${Info}) {
    margin-left: ${({ gap }) =>
      spacing(gap === 'lg' ? 5 : gap === 'auto' ? 0 : 0.25)};
  }

  ${({ size }) =>
    size === 'sm' &&
    css`
      ${Info} {
        ${typography('body2')};
      }

      & svg {
        width: 16px;
      }
    `}

  ${({ size }) =>
    size === 'lg' &&
    css`
      ${Info} {
        ${typography('body1')};
      }
      & svg {
        width: 40px;
        height: 38px;
      }
    `}
`
